import { createGlobalState } from '@vueuse/core';

const useGenerateIds = createGlobalState(() => {
    let id = 1;
    return function() {
        return `fe--id--${id++}`;
    };
});
export default useGenerateIds;
